export default __webpack_public_path__ + "static/cloud-a1cb28cc68facc39ce4e15ab725d3f578718d18c8f29ca3752c468b5d244b9ac.png";